export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7781.2391a0ec.jpg";